import React from 'react';
import { EntityLayoutAvatar } from './entity-layout-avatar';
import { EntityLayoutSocials } from './entity-layout-socials';
import { StyledContainer } from './entity-layout.styles';
import { IEntityLayoutContainer } from './entity-layout.types';

export const EntityLayoutContainer: IEntityLayoutContainer = ({ children }) => (
    <StyledContainer>{children}</StyledContainer>
);

EntityLayoutContainer.Avatar = EntityLayoutAvatar;
EntityLayoutContainer.Socials = EntityLayoutSocials;
